import { render, staticRenderFns } from "./CompanyShortLayout.vue?vue&type=template&id=96fdbbb4&scoped=true"
import script from "./CompanyShortLayout.vue?vue&type=script&lang=js"
export * from "./CompanyShortLayout.vue?vue&type=script&lang=js"
import style0 from "./CompanyShortLayout.vue?vue&type=style&index=0&id=96fdbbb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fdbbb4",
  null
  
)

export default component.exports